import { render, staticRenderFns } from "./OrgDashboardStatsSysAdminUi.vue?vue&type=template&id=14bbe85c&scoped=true&"
import script from "./OrgDashboardStatsSysAdminUi.vue?vue&type=script&lang=js&"
export * from "./OrgDashboardStatsSysAdminUi.vue?vue&type=script&lang=js&"
import style0 from "./OrgDashboardStatsSysAdminUi.vue?vue&type=style&index=0&id=14bbe85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bbe85c",
  null
  
)

export default component.exports